import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';
import CheckInput, { InputType } from '../../../../../../../atoms/CheckInput';

import css from './BooksPaymentCard.module.scss';

interface Props extends React.ComponentProps<'input'> {
  className?: string;
  tailDigits: string;
  onChange?: (e: React.ChangeEvent) => void;
}

const BooksPaymentCard = ({
  className,
  tailDigits,

  onChange,
  ...attr
}: Props) => {
  const classes = classNames(css.BooksPaymentCard, className);
  const intl = useIntl();

  return (
    <div className={classes}>
      {/* @ts-expect-error strictFunctionTypes */}
      <CheckInput
        {...attr}
        type={InputType.Radio}
        name="payment-creditcard"
        onChange={onChange}
      >
        {intl.formatMessage({ id: 'books.paymentMethod.history' })}
        <span className={css.BooksPaymentCard__Card}>
          <span className={css.BooksPaymentCard__Mask}>•••• •••• •••• </span>
          {tailDigits}
        </span>
      </CheckInput>
    </div>
  );
};

export default BooksPaymentCard;
